import type { SelectOption } from '@didaskill/types/web';

// Reorder values by putting fixed values first.
export const orderValues = <TOption extends SelectOption<any>>(values: readonly TOption[]) =>
  values.filter((v) => v.isFixed).concat(values.filter((v) => !v.isFixed));
